"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageEditorDialog = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Dialog_1 = __importDefault(require("@opsbase/web-dialogs/Dialog"));
const DialogSize_1 = __importDefault(require("@opsbase/web-dialogs/Dialog/DialogSize"));
const AnnotateIcon_1 = __importDefault(require("@opsbase/web-icons/icons/AnnotateIcon"));
const CropIcon_1 = __importDefault(require("@opsbase/web-icons/icons/CropIcon"));
const RedoIcon_1 = __importDefault(require("@opsbase/web-icons/icons/RedoIcon"));
const UndoIcon_1 = __importDefault(require("@opsbase/web-icons/icons/UndoIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const Spinner_1 = __importDefault(require("@opsbase/web-ui/Spinner"));
const cropperjs_1 = __importDefault(require("cropperjs"));
const react_1 = __importStar(require("react"));
const react_signature_canvas_1 = __importDefault(require("react-signature-canvas"));
const CANVAS_SIZE = 500;
const makeMyClasses = busy => ({
    container: {
        width: CANVAS_SIZE,
        margin: 'auto',
        height: 460,
    },
    spinner: {
        opacity: busy ? 1 : 0,
        pointerEvents: 'none',
        position: 'absolute',
        backgroundColor: lib_palette_1.default.WhiteSmoke.main,
        paddingTop: 40,
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        transition: 'opacity 0.3s',
    },
    canvas: {
        border: `1px solid ${lib_palette_1.default.InputBorderGrey.main}`,
        borderRadius: 4,
        width: '100%',
        display: 'block',
    },
});
function ImageEditorDialog(props) {
    const { maxImageWidth = 500, dataUrl, onAccept, onCancel } = props;
    const [history, setHistory] = (0, react_1.useState)([dataUrl]);
    const [historyCursor, setHistoryCursor] = (0, react_1.useState)(0);
    const [busy, setBusy] = (0, react_1.useState)();
    const [cropMode, setCropMode] = (0, react_1.useState)(false);
    const [drawMode, setDrawMode] = (0, react_1.useState)(false);
    const sigRef = (0, react_1.useRef)();
    const cropperRef = (0, react_1.useRef)();
    const sigRefEl = sigRef.current;
    const canRedo = historyCursor > 0;
    const canUndo = historyCursor < (history === null || history === void 0 ? void 0 : history.length) - 1;
    const myCss = (0, web_css_1.default)(makeMyClasses, [busy]);
    const _doAddDataUrlToHistory = (0, react_1.useMemo)(() => newDataUrl => {
        setHistory([newDataUrl, ...history]);
    }, [history]);
    const _doLoadDataUrl = (0, react_1.useMemo)(() => newDataUrl => {
        setBusy(true);
        setTimeout(() => {
            const image = new Image();
            image.src = newDataUrl;
            image.onload = () => {
                const canvas = sigRef.current.getCanvas();
                canvas.width = CANVAS_SIZE;
                canvas.height = CANVAS_SIZE;
                sigRef.current.clear();
                const scaleX = image.width / CANVAS_SIZE;
                const scaleY = image.height / CANVAS_SIZE;
                const scale = Math.max(scaleX, scaleY);
                canvas.getContext('2d').scale(1 / scale, 1 / scale);
                canvas
                    .getContext('2d')
                    .drawImage(image, ((CANVAS_SIZE - image.width / scale) / 2) * scale, ((CANVAS_SIZE - image.height / scale) / 2) * scale);
                canvas.getContext('2d').scale(scale, scale);
                setBusy(false);
            };
        }, 0);
    }, []);
    const _doSetDrawMode = (0, react_1.useMemo)(() => onOff => {
        if (!sigRef.current)
            return;
        if (onOff)
            sigRef.current.on();
        else
            sigRef.current.off();
        setDrawMode(onOff);
    }, []);
    const _doSetCropMode = (0, react_1.useMemo)(() => onOff => {
        if (!sigRef.current)
            return;
        if (onOff && !cropperRef.current) {
            setBusy(true);
            setTimeout(() => {
                cropperRef.current = new cropperjs_1.default(sigRef.current.getCanvas(), {
                    movable: false,
                    rotatable: false,
                    scalable: false,
                    zoomable: false,
                });
                setTimeout(() => setBusy(false), 500);
            }, 0);
        }
        if (!onOff && !!cropperRef.current) {
            setBusy(true);
            setTimeout(() => {
                cropperRef.current.destroy();
                cropperRef.current = undefined;
                setTimeout(() => setBusy(false), 200);
            }, 500);
        }
        setCropMode(onOff);
    }, []);
    (0, react_1.useEffect)(() => _doLoadDataUrl(dataUrl), [_doLoadDataUrl, dataUrl]);
    (0, react_1.useEffect)(() => sigRefEl === null || sigRefEl === void 0 ? void 0 : sigRefEl.off(), [sigRefEl]);
    const handleChangeDraw = (0, react_1.useCallback)(() => {
        _doAddDataUrlToHistory(sigRef.current.getCanvas().toDataURL('image/png'));
    }, [_doAddDataUrlToHistory]);
    const handleToggleCrop = (0, react_1.useCallback)(() => {
        _doSetCropMode(!cropMode);
        _doSetDrawMode(false);
    }, [_doSetDrawMode, _doSetCropMode, cropMode]);
    const handleToggleAnnotate = (0, react_1.useCallback)(() => {
        _doSetCropMode(false);
        _doSetDrawMode(!drawMode);
    }, [_doSetDrawMode, _doSetCropMode, drawMode]);
    const handleCropAccept = (0, react_1.useCallback)(() => {
        if (!cropMode)
            return;
        const newDataUrl = cropperRef.current.getCroppedCanvas().toDataURL('image/png');
        _doAddDataUrlToHistory(newDataUrl);
        _doLoadDataUrl(newDataUrl);
        _doSetCropMode(false);
    }, [_doAddDataUrlToHistory, _doLoadDataUrl, _doSetCropMode, cropMode]);
    const handleClickAccept = (0, react_1.useCallback)(() => {
        const canvas = sigRef.current.getCanvas();
        const resizeCanvas = document.createElement('canvas');
        const resizeCtx = resizeCanvas.getContext('2d');
        const scale = canvas.width > maxImageWidth ? maxImageWidth / canvas.width : 1;
        const scaleW = canvas.width * scale;
        const scaleH = canvas.height * scale;
        resizeCanvas.width = scaleW;
        resizeCanvas.height = scaleH;
        resizeCtx.drawImage(canvas, 0, 0, scaleW, scaleH);
        onAccept(resizeCanvas.toDataURL('image/png'));
    }, [maxImageWidth, onAccept]);
    const handleClickCancel = (0, react_1.useCallback)(() => {
        if (!cropMode)
            onCancel();
        else
            _doSetCropMode(false);
    }, [_doSetCropMode, cropMode, onCancel]);
    const handleUndo = (0, react_1.useCallback)(() => {
        if (!canUndo)
            return;
        const newHistoryCursor = historyCursor + 1;
        setHistoryCursor(newHistoryCursor);
        _doLoadDataUrl(history[newHistoryCursor]);
    }, [_doLoadDataUrl, canUndo, history, historyCursor]);
    const handleRedo = (0, react_1.useCallback)(() => {
        if (!canRedo)
            return;
        const newHistoryCursor = historyCursor - 1;
        setHistoryCursor(newHistoryCursor);
        _doLoadDataUrl(history[newHistoryCursor]);
    }, [_doLoadDataUrl, canRedo, history, historyCursor]);
    return (react_1.default.createElement(Dialog_1.default, { size: DialogSize_1.default.X800_Y600, closable: false },
        react_1.default.createElement(Vertical_1.default, { gutter: true },
            react_1.default.createElement(Pane_1.default, { grow: true },
                react_1.default.createElement("div", { className: myCss.container },
                    react_1.default.createElement(react_signature_canvas_1.default, { ref: sigRef, penColor: lib_palette_1.default.primary.main, canvasProps: { className: myCss.canvas }, onEnd: handleChangeDraw }),
                    react_1.default.createElement("div", { className: myCss.spinner },
                        react_1.default.createElement(Spinner_1.default, { startDelay: 0, busy: true })))),
            !cropMode && (react_1.default.createElement(Horizontal_1.default, { shrink: true, gutter: true },
                react_1.default.createElement(Pane_1.default, { grow: true }),
                react_1.default.createElement(Button_1.default, { tooltip: lib_i18n_1.default.t('crop-image'), round: true, disabled: !canUndo, background: !cropMode, icon: react_1.default.createElement(UndoIcon_1.default, { size: 18 }), onClick: handleUndo }),
                react_1.default.createElement(Button_1.default, { tooltip: lib_i18n_1.default.t('crop-image'), round: true, disabled: !canRedo, background: !cropMode, icon: react_1.default.createElement(RedoIcon_1.default, { size: 18 }), onClick: handleRedo }),
                react_1.default.createElement(Button_1.default, { tooltip: lib_i18n_1.default.t('crop-image'), round: true, background: !cropMode, icon: react_1.default.createElement(CropIcon_1.default, { size: 18 }), onClick: handleToggleCrop }),
                react_1.default.createElement(Button_1.default, { tooltip: lib_i18n_1.default.t('draw-image'), round: true, background: !drawMode, icon: react_1.default.createElement(AnnotateIcon_1.default, { size: 18 }), onClick: handleToggleAnnotate }),
                react_1.default.createElement(Pane_1.default, { grow: true }))),
            react_1.default.createElement(Horizontal_1.default, { shrink: true, gutter: true },
                react_1.default.createElement(Pane_1.default, { grow: true }),
                react_1.default.createElement(Button_1.default, { style: { minWidth: 132 }, color: lib_palette_1.default.LavendarGrey, label: lib_i18n_1.default.t('cancel'), onClick: handleClickCancel }),
                cropMode && (react_1.default.createElement(Button_1.default, { style: { minWidth: 132 }, color: lib_palette_1.default.primary, tooltip: lib_i18n_1.default.t('crop-image'), label: lib_i18n_1.default.t('crop'), onClick: handleCropAccept })),
                !cropMode && (react_1.default.createElement(Button_1.default, { style: { minWidth: 132 }, color: lib_palette_1.default.positive, label: lib_i18n_1.default.t('done'), onClick: handleClickAccept })),
                react_1.default.createElement(Pane_1.default, { grow: true })))));
}
exports.ImageEditorDialog = ImageEditorDialog;
exports.default = ImageEditorDialog;
